import { LogCategory, LogKind } from './log.types';
var registeredLoggers = new Map();
export function addLogger(name, loggerObj) {
    if (registeredLoggers.has(name)) {
        throw new Error("Logger " + name + " already exists");
    }
    registeredLoggers.set(name, loggerObj);
}
export function removeLogger(name) {
    registeredLoggers.delete(name);
}
export function broadcastLogger(options) {
    broadCastTo(options, registeredLoggers);
}
export function addAdditionalLoggers(additionalLoggers) {
    if (additionalLoggers) {
        Object.keys(additionalLoggers).forEach(function (key) {
            addLogger(key, { logger: additionalLoggers[key] });
        });
    }
}
export function flush() {
    var flushArray = [];
    registeredLoggers.forEach(function (loggerObj) {
        if (loggerObj.flush) {
            flushArray.push(loggerObj.flush());
        }
    });
    return Promise.all(flushArray);
}
function broadCastTo(options, loggers) {
    // eslint-disable-next-line @typescript-eslint/typedef
    loggers.forEach(function (loggerObj, name) {
        try {
            loggerObj.logger(options);
        }
        catch (error) {
            var restLoggers = new Map(loggers);
            restLoggers.delete(name);
            broadCastTo({
                id: '500294',
                type: LogKind.Error,
                logCategory: LogCategory.ClientError,
                message: "Failure in logger: " + name,
                error: error instanceof Error ? error : new Error(String(error)),
            }, restLoggers);
        }
    });
}
/**
 * Log messages
 */
export var log = broadcastLogger;
